<div class="modal-header">
  <h3>Select accounting system(s)</h3>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>
<div class="modal-body">
  <p class="helper-text">
    This vendor will be created in the accounting system(s) you select below.
    Pick one, several, or select all.
  </p>
  <label class="form-label" requiredAsterisk>Accounting system(s)</label>
  <app-multi-select
    [Items]="ApConfigsMap"
    (selectedItemsChange)="apConfigMapChange($event)"
  ></app-multi-select>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-ghost" (click)="close()">Cancel</button>
  <button
    type="button"
    class="btn btn-primary"
    [disabled]="!hasSelection"
    (click)="submit()"
  >
    Create vendor
  </button>
</div>
